import React from 'react';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { useAppSelector } from '@/hooks/useAppSelector';
import { closeModal } from '@/slice/modal';
import { CancelBooking } from './CancelBooking';
import { RescheduleModal } from './RescheduleModal';
import { LateCancelPolicy } from './LateCancelPolicy';
import { LateCancelConfirm } from './LateCancelConfirm';
import { CompleteBooking } from './CompletedCall';
import { ConsultantFeedbackModal } from './ConsultantFeedback';
import { KeepFee } from './KeepFee';
import { RejectReschedule } from './RejectReschedule';

const MODAL_COMPONENTS: Record<string, React.FC<any>> = {
  CANCEL_BOOKING: CancelBooking,
  RESCHEDULE_BOOKING: RescheduleModal,
  LATE_CANCEL_POLICY: LateCancelPolicy,
  LATE_CANCEL_CONFIRM: LateCancelConfirm,
  COMPLETE_BOOKING: CompleteBooking,
  FEEDBACK_BOOKING: ConsultantFeedbackModal,
  KEEP_FEE: KeepFee,
  REJECT_RESCHEDULE: RejectReschedule,
};

export const ModalController: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isOpen, modalType, modalProps } = useAppSelector(
    (state) => state.modal,
  );

  if (!isOpen || !modalType) return null;

  const ModalComponent = MODAL_COMPONENTS[modalType];

  return (
    <ModalComponent
      open={isOpen}
      onCancel={() => dispatch(closeModal())}
      {...modalProps}
    />
  );
};
